var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52266 4.62891H17.0861C18.1496 4.62891 18.6857 4.01367 18.6857 2.95898V2.12402C18.6857 1.06934 18.1496 0.454102 17.0861 0.454102H2.52266C1.50312 0.454102 0.914257 1.06934 0.914257 2.12402V2.95898C0.914257 4.01367 1.45918 4.62891 2.52266 4.62891ZM4.9748 16.8809H14.6252C16.4357 16.8809 17.4289 15.9141 17.4289 14.1035V5.9209H2.17109V14.1035C2.17109 15.9141 3.16426 16.8809 4.9748 16.8809ZM6.96992 9.27832C6.55684 9.27832 6.25801 8.97949 6.25801 8.54883V8.26758C6.25801 7.82812 6.55684 7.53809 6.96992 7.53809H12.6389C13.0607 7.53809 13.3596 7.82812 13.3596 8.26758V8.54883C13.3596 8.97949 13.052 9.27832 12.6389 9.27832H6.96992Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.83c234baf9794c30a3ce0ac67b14ce35.svg";
export { ForwardRef as ReactComponent };